import EnhancedButton from '@components/button/EnhancedButton';
import ShowForUser from '@components/common/ShowForUser';
import { IDynamicDiplayView } from '@components/widgets/dynamic-display';
import DynamicWidget from '@components/widgets/dynamic-display/DynamicWidget';
import { IAbstractRecord } from '@models';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import SalesForceBusinessUserAuthoritiesDrawer from './salesforce-business-users-authorities-drawer/SalesForceBusinessUserAuthoritiesDrawer';

interface IProductionAuthorities {
  businessUserStatus: string;
  data: IAbstractRecord;
  onSuccess: () => void;
}

const ProductionAuthorities: React.FC<IProductionAuthorities> = ({
  businessUserStatus,
  data,
  onSuccess,
}) => {
  const { id: entityId } = useParams<{ id: string }>();
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>();

  const authoritiesView: IDynamicDiplayView = {
    name: 'Business User Authorities',
    sections: [
      {
        name: 'authoritiesDetails',
        title: 'Production Authorities',
        showActionButtons: true,
        properties: {
          editableLineCharges: {
            value: data.editableLineChargesTitle,
            name: 'editableLineCharges',
            title: 'Editable Line Charges',
            multiline: false,
          },
          allowPolicyEndDateEdits: {
            value: data.allowPolicyEndDateEdits ? 'Yes' : 'No',
            name: 'allowPolicyEndDateEdits',
            title: 'Allow Policy End Date Edits',
            multiline: false,
          },
          allowPlanCoverEdits: {
            value: data.allowPlanCoverEdits ? 'Yes' : 'No',
            name: 'allowPlanCoverEdits',
            title: 'Allow Plan Cover Edits',
            multiline: false,
          },
          allowClauseEdits: {
            value: data.allowClauseEdits ? 'Yes' : 'No',
            name: 'allowClauseEdits',
            title: 'Allow Clause Edits',
            multiline: false,
          },
          allowGroupPolicy: {
            value: data.allowGroupPolicy ? 'Yes' : 'No',
            name: 'allowGroupPolicy',
            title: 'Allow Group Policy',
            multiline: false,
          },
          allowEndorsement: {
            value: data.allowEndorsement ? 'Yes' : 'No',
            name: 'allowEndorsement',
            title: 'Allow Endorsement',
            multiline: false,
          },
          allowEndorsementCostEdits: {
            value: data.allowEndorsementCostEdits ? 'Yes' : 'No',
            name: 'allowEndorsementCostEdits',
            title: 'Allow Endorsement Cost Edits',
            multiline: false,
          },
          allowPolicyCorrection: {
            value: data.allowPolicyCorrection ? 'Yes' : 'No',
            name: 'allowPolicyCorrection',
            title: 'Allow Policy Correction',
            multiline: false,
          },
        },
      },
    ],
  };

  return (
    <>
      <DynamicWidget
        hasFourFields
        view={authoritiesView}
        actions={
          <ShowForUser allowedRoles={['Insurance-Admin']}>
            {businessUserStatus !== 'inactive' && (
              <EnhancedButton
                type="button"
                isPrimary
                onClick={() => setIsDrawerOpen(true)}
              >
                Modify
              </EnhancedButton>
            )}
          </ShowForUser>
        }
      />
      {isDrawerOpen && (
        <SalesForceBusinessUserAuthoritiesDrawer
          open={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          onSuccess={() => {
            setIsDrawerOpen(false);
            onSuccess();
          }}
          businessUserId={entityId}
          authoritiesDetailsInfo={data as any}
        />
      )}
    </>
  );
};

export default ProductionAuthorities;
